export const isEmpty = (variable: any): boolean => {
  return variable === undefined || variable === null || variable === '';
};
